import {http} from "../http";

export interface Swift{
    trnRequestType : string;
    PMTCUSTID : string;
    CUSTCIF : string;
    CUSTACC : string;
    AMOUNT : number;
    BENEFNAME : string;
    BENEFADDR : string;
    BENEFACC : string;
    BENEFBANKCODE : string;
    BENEFBANKNAME : string;
    BENEFBANKADDR : string;
    INTERMEDBANKCODE : string;
    INTERMEDBANKNAME : string;
    INTERMEDBANKADDR : string;
    PMTDET : string;
    INFOTOBENEF : string;
    NOTE : string;
    CUSTACCFORCOM : string;
}

export const newMoneyTransferSwift = async (request_data: Swift): Promise<Swift> => {
    const { data } = await http.post<Swift>("moneytransfer/swift", request_data);
    return data;
};
export const getSwiftPdf = async (ibankRef:any):Promise<any> =>{
    const {data} = await http.post(`file/get-swift_message-pdf`,ibankRef)
    return data;
}

export const getcrosscurrency = async (req:any):Promise<any> =>{
     const {data} = await http.post(`exchange/getcrosscurrency`,req)
    return data;
}